import { deleteData, getData, patchData, postData } from "../api/api";
import type { IntentRule } from "../types/intentRule";
import { buildReadQueryString } from "../lib/api/readQuery";

const INTENT_RULE_BASE_URL = "/intent-rule";

export const intentRuleService = {
  // List intent rules (DataTableWithPagination will pass page/size/sort/search)
  readIntentRules: async (fields?: string | string[]) => {
    return getData(`${INTENT_RULE_BASE_URL}/read?${buildReadQueryString({ fields })}`);
  },

  getIntentRule: async (id: string) => {
    return getData(`${INTENT_RULE_BASE_URL}/read/${id}`);
  },

  createIntentRule: async (data: IntentRule) => {
    return postData(`${INTENT_RULE_BASE_URL}/create`, data);
  },

  updateIntentRule: async (data: IntentRule) => {
    return patchData(`${INTENT_RULE_BASE_URL}/update`, data);
  },

  deleteIntentRule: async (id: string) => {
    return deleteData(`${INTENT_RULE_BASE_URL}/delete/${id}`);
  },
};

